import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = null;

const setPolicies = (state, action) => action.payload;

const clearSearch = () => initialState;

const policySearchReducer = {
	[types.SET_POLICIES]: setPolicies,
	[types.CLEAR_SEARCH]: clearSearch,
};

export default handleActions(policySearchReducer, initialState);
